export const obtenerValorReservaAdultos = ({entidad, habitacion, numNoches})=>{



    let numAdultos = entidad.numAcompanantes
    let total = 0
    if (numAdultos <= 1) {
        total = habitacion.tarifa
    }else if (numAdultos === 2) {
        total = habitacion.tarifaAcompanante
    }else if (numAdultos > 2) {
        total = entidad.numAcompanantes * habitacion.tarifaAdultos
    }



    return total * numNoches

}